import React from "react";
import {
  Collapse,
  IconButton,
  Grid,
  Typography,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { makeStyles } from'@mui/styles';

const useStyles = makeStyles({
  question: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 24,
    lineHeight: "150%",
    color: "#001B11",
  },
  answer: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: 18,
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#001B11",
    padding: "24px 0 24px 24px",
  },
  showhide_answer: {
    backgroundColor: "rgba(245, 244, 242, 0.9)",
    cursor: "pointer",
  },
});

function CustomCollapse(props) {
  const [open, setOpen] = React.useState(false);
  const { question, answer } = props;
  const classes = useStyles();

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      <Typography className={classes.question} role="heading" aria-level="2">{question}</Typography>
      <Container maxWidth="100px" role="button" aria-expanded={open}>
        <Box my={2} className={classes.showhide_answer}>
          <Grid
            item
            display= "flex"
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <div className={classes.contDiv} style={{marginTop: !open ? "-20px" : ""}}>
              <Collapse collapsedSize="3.2rem" in={open}>
                <Typography onClick={handleOpen} className={classes.answer} id="answer-content">
                  {answer}
                </Typography>
              </Collapse>
            </div>
            <IconButton onClick={handleOpen} size="large">
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default CustomCollapse;
